import React, { useState, useEffect, useRef } from 'react'
import Maybe from 'components/__new/common/Maybe';
import { ReactComponent as IconAdd } from "assets/images/icons/project-icons/plus-light.svg"
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import SearchableBillPaymentProviders from '../Providers';
import { SelectInput } from 'components/__new/common/form';
import useLoginInfo from 'hooks/useLoginInfo';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import { electricityPurchaseValidation } from 'store/entities/billPayment/action';


const MultiplePowerPurchase = ({
    togglePurchaseModal,
    isWideViewOpen,
    setIsWideViewOpen,
    previewItems,
    setPreviewItems,
}) => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const searchableBillPaymentProvidersRef = useRef();
    const [form, setForm] = useState({
        network: {},
        phoneNumber: "",
        amount: "",
        accountType: "",
        account: "",
        name: "",
        address: "",
    });
    
    // eslint-disable-next-line
    const [beneficiariesShown, setBeneficiariesShown] = useState(false);
    const { electricityValidationLoading: isValidating, electricityValidation: validatedData } = useSelector((s) => s.entities.billPayment);    
    const [validatedMeter, setValidatedMeter] = useState(null);
    
    const onClose = () => {
        togglePurchaseModal();
    }
    
    const resetValues = () => {
        setForm({
            network: {},
            phoneNumber: "",
            amount: "",
            accountType: "",
            account: "",
            name: "",
            address: "",
        });
        searchableBillPaymentProvidersRef?.current?.clearSearchableBillPaymentProviders();
        setValidatedMeter(null);
    }
    
    const addRecipient = (e) => {
        e.preventDefault();
        
        const duplicateItem = previewItems?.find((item) => item?.account === form.account)
        
        if(previewItems?.length === 20) {
            toast.error(`You can only add ${previewItems?.length} recipients`)
        } else {
            if(!form?.network?.label) {
                toast.error("Please select a biller")
            } else if(!form.accountType?.length) {
                toast.error("Please select a meter type")
            } else if(form.account?.length !== 11) {
                toast.error("Please enter a valid meter number")
            } else if(form.phone?.length !== 11) {
                toast.error("Please enter a valid phone number")
            } else if(duplicateItem) {
                toast.error(`${duplicateItem?.account} has already been added`)
            } else {
                setPreviewItems([
                    ...previewItems,
                    {...form, amount: 0, fee: 0}
                ]);
                setIsWideViewOpen(true);
                resetValues();
            }
        }
    }
    
    useEffect(() => {
        if(form?.account?.length === 11 && form?.accountType?.length && form?.network?.value?.length) {
            const params = {
                account: form.account,
                accountType: form.accountType,
                service: form.network?.value,
                userId: userInfo.employer._id,
            }
            
            dispatch(electricityPurchaseValidation(params));
        }
        // eslint-disable-next-line
    }, [form?.account, form?.accountType, form?.network])
    
    
    useEffect(() => {
        if(validatedData?.status === 'success' && form?.account?.length === 11) {
            setValidatedMeter(validatedData?.response);
            setForm({
                ...form,
                name: validatedData?.response?.name,
                address: validatedData?.response?.address
            })
        }
        // eslint-disable-next-line
    }, [validatedData])
    
    
    useEffect(() => {
        setPreviewItems([]);
        searchableBillPaymentProvidersRef?.current?.clearSearchableBillPaymentProviders();
        setValidatedMeter(null);
        setForm({
            network: {},
            phoneNumber: "",
            amount: "",
            accountType: "",
            account: "",
            name: "",
            address: "",
        });
        // eslint-disable-next-line
    }, [])
    
    return (
        <div className='w-full relative'>
            <form onSubmit={addRecipient}>
                <div className="w-full">
                    
                    <div className="relative">
                        <SearchableBillPaymentProviders
                            type="electricity"
                            label="Biller"
                            tag="products"
                            ref={searchableBillPaymentProvidersRef}
                            onValueChange={(e) => {
                                setForm({...form, network: e, amount: "", account: ""});
                                setValidatedMeter(null);
                            }}
                        />
                        
                        {/* <div onClick={() => setBeneficiariesShown(!beneficiariesShown)} className='text-sm cursor-pointer border-b border-ep-primary-600 text-ep-primary-600 absolute -bottom-6'>
                            {beneficiariesShown ? "Close search" : "Or Search Beneficiary List"}
                        </div> */}
                    </div>
                    
                    <div className="mt-6">
                        <SelectInput label="Meter Type" value={form.accountType} onChange={(e) => {setForm({...form, accountType: e.target.value})}}>
                            <option value="" disabled>Select</option>
                            <option value="prepaid">Prepaid</option>
                            <option value="postpaid">Postpaid</option>
                        </SelectInput>
                    </div>
                    
                    <div className='form-group relative'>
                        <label>Meter Number</label>
                        <input
                            type="number"
                            id="prl-input"
                            className="form-input"
                            value={form.account}
                            placeholder="Enter Meter Number"
                            onChange={(e) => setForm({...form, account: e.target.value})}
                        />
                        
                        <Maybe condition={validatedMeter !== null}>
                            <div className="w-full flex items-center justify-start absolute -bottom-7">
                                <div className="flex items-center text-sm">
                                    <IconCheckCircle width={15} />
                                    <div className='ml-1.5 text-[#153344] capitalize text-xs'>{validatedMeter?.name?.toLowerCase()}</div>
                                </div>
                            </div>
                        </Maybe>
                    </div>
                    
                    <div className='my-10' />
                    
                    <div className="form-group">
                        <label>Phone Number</label>
                        <input
                            type="number"
                            id="prl-input"
                            className="form-input"
                            value={form.phone || ""}
                            placeholder="Enter Phone Number"
                            onChange={(e) => setForm({...form, phone: e.target.value})}
                        />
                    </div>
                </div>
                
                <div className="pt-5 border-t mt-5">
                    <button disabled={isValidating} type="submit" className="btn btn-transparent-primary w-full disabled:cursor-not-allowed">
                        <IconAdd width={15} />&nbsp;
                        Add Another
                    </button>
                </div>
                
                <Maybe condition={isWideViewOpen === false}>
                    <div className="w-full flex items-center justify-end pt-8">
                        <button type="button" onClick={onClose} className="btn btn-transparent-primary mr-3">
                            Cancel
                        </button>
                        
                        <button disabled type="button" className="btn btn-ep-primary">
                            {isValidating ? "Validating..." : "Continue"}
                        </button>
                    </div>
                </Maybe>
            </form>
        
            <Maybe condition={beneficiariesShown}>
                {/* <BeneficiariesList
                    addBatchBeneficiaries={addBatchBeneficiaries}
                /> */}
            </Maybe>
        </div>
    )
}


export default MultiplePowerPurchase